<template>
  <div class='button-wrapper' :class='buttonWrapperClasses' :style='buttonWrapperStyles'>
    <div class='button-stack'>
      <transition mode='out-in' name="button"
                          :enter-active-class="animationClasses.enter"
                          :leave-active-class="animationClasses.leave">
        <a key='clicked' :style='buttonStyles' v-if='!state' @click.prevent='click' class='action-button' >
          <ContentEditable :editable='editable' tag='span' v-model='content.beforeText' :translated="translatedBefore"></ContentEditable>
          <span v-if='editable'>
          <a class='state-switcher' @click.prevent='switchState'><ion-icon name='play-skip-forward'></ion-icon></a>
          <a class='state-switcher' @click.prevent='onEdit'><ion-icon name='settings'></ion-icon></a>
        </span>
        </a>
        <a key='not-clicked' :style='buttonStyles' v-if='state' @click.prevent='click' class='action-button'>
          <ContentEditable :editable='editable' tag='span' v-model='content.afterText' :translated="translatedAfter"></ContentEditable>
          <span v-if='editable'>
          <a class='state-switcher' @click.prevent='switchState'><ion-icon v-if='state' name='play-skip-back'></ion-icon></a>
          <a class='state-switcher' @click.prevent='onEdit'><ion-icon name='settings'></ion-icon></a>
        </span>
        </a>
      </transition>
    </div>
  </div>
</template>
<script>
import ContentEditable from '../../ContentEditable.vue'
import ReportEvents from '../lib/ReportEvents'
export default {
  props: {
    editable: {type: Boolean, default: false},
    config: {type: Object, default: ()=>{}},
    toggle: {type: Boolean, default: false},
    translatedBefore: {type: String, default: null},
    translatedAfter: {type: String, default: null},
    link: {type: String, default: null}
  },
  components: {
    ContentEditable
  },
  inject: ['globalTheme'],
  data () {
    return {
      state: false,
      content: {}
    }
  },
  computed: {
    animationClasses () {
      if (!this.content.animated){
        return ''
      }
      let classes =  {
        enter: `animate__animated animate__${this.content.animation.enter}`,
        leave: `animate__animated animate__${this.content.animation.leave}`
      }
      return classes
    },
    buttonWrapperStyles () {
      return {
        textAlign: this.content.align
      }
    },
    buttonWrapperClasses () {
      return [
        'aligned-' + this.content.align
      ]
    },
    buttonStyles () {
      let br = this.globalTheme.borderRadius || 0
      let style = {
        borderRadius: br + 'px'
      }

      style.backgroundColor = this.content.theme.backgroundColor || this.globalTheme.buttonColor
      style.color = this.content.theme.color || this.globalTheme.buttonTextColor
      return style
    }
  },
  methods: {
    click (){
      if (this.state === true && !this.toggle === true || this.editable === true){
        return
      }
      let eventPayload = {name: this.content.event, label: this.content.label || ''}
      if(this.link){
        eventPayload.context = {link: this.link}
      }
      ReportEvents.$emit('ctaEvent', eventPayload);
      this.$emit('click', this.state)
      if(this.link){
        window.open(this.link, '_blank')
      } else {
        this.state = !this.state
      }
    },
    switchState () {
      this.state = !this.state
    },
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'ButtonEditPanel'})
    },
    onChange() {
      this.$emit('change', this.content)
    }
  },
  created () {
    this.content = this.config
    this.$watch('content', this.onChange, {deep: true})
  }
}
</script>
<style lang='scss' scoped>
.button-wrapper {
  margin-top: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  .action-button {
    width: auto;
    display: inline-block;
    background-color: #fbd147;
    color: black;
    border: none;
    font-weight: bold;
    min-width: 110px;
    border-radius: 500px;
    padding: 10px 3rem;
    cursor: pointer;
    border: 1px solid transparent;
    font-size: 120%;
    &:hover {
      background-color: darken(#fbd147, 15%);
    }
    ::v-deep .content-editable {
      display: inline;
      div {
        display: inline;
      }
    }
  }

  .actions {
    bottom:-37px;
    left: 0;
    right: 0;
    margin: 3px auto;
    text-align: left;
  }

}

.button-wrapper.aligned-center {
  align-items: center;
}

.button-wrapper.aligned-right {
  align-items: flex-end;
  .actions {
    //text-align: right;
  }
}

  a.state-switcher {
    vertical-align: middle;
    display: inline-block;
    font-size: 18px;
    width: 18px;
    height: 18px;
    }
</style>